import { addColumns } from '@nozbe/watermelondb/Schema/migrations'

export default {
  toVersion: 3,
  steps: [
    addColumns({
      table: 'chats',
      columns: [{ name: 'normalized_search', type: 'string' }]
    })
  ]
}
